module.exports = __webpack_public_path__ + "static/media/id1-virginia.1867828b.jpg";